import React from "react";
import { useFeatureFlagsSelector } from "store/reducers";

const FeatureGate = ({ featureKey, fallback = null, children }) => {
  const featureFlags = useFeatureFlagsSelector();

  if (!featureKey || featureFlags?.[featureKey] !== true) {
    return fallback;
  }

  return <>{children}</>;
};

export default FeatureGate;
